// Layout-math constants only: the panel budget (usePanelSpaceBudget) runs
// this arithmetic for the skeleton before any component mounts, so nothing
// here may import one.

/** Transcript column, padding included (ChatPane's content wrapper). */
export const TRANSCRIPT_COLUMN_WIDTH = 704;

/** Composer column at md+, padding included (ChatInputArea). */
export const COMPOSER_COLUMN_WIDTH = 736;

/**
 * Upper bound on one thin scrollbar (globals.css: `scrollbar-width: thin`,
 * 8px WebKit; Chromium reserves ~10px). The transcript scroller keeps one on
 * each edge via `scrollbar-gutter: stable both-edges`, and both come out of
 * the chat pane before the transcript column gets its width.
 */
export const SCROLLBAR_GUTTER_ALLOWANCE = 12;

/**
 * Narrowest chat pane at which neither column has to re-wrap. Side panels
 * collapse before the pane drops below this, so resizing shrinks the
 * columns' margins, never the text.
 */
export const MIN_CHAT_PANE_WIDTH = Math.max(
  COMPOSER_COLUMN_WIDTH,
  TRANSCRIPT_COLUMN_WIDTH + 2 * SCROLLBAR_GUTTER_ALLOWANCE,
);
